import { render, staticRenderFns } from "./InertialForceViz.vue?vue&type=template&id=074bdc2e&scoped=true"
import script from "./InertialForceViz.vue?vue&type=script&lang=js"
export * from "./InertialForceViz.vue?vue&type=script&lang=js"
import style0 from "./InertialForceViz.vue?vue&type=style&index=0&id=074bdc2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074bdc2e",
  null
  
)

export default component.exports